import React, { useState } from "react";
import ReportDashboard from "./ReportDashboard";
import "../../css/ReportsManagement/ReportsManagement.css";
import {
  ArrowDown2,
  ArrowUp2,
  DocumentText,
  TaskSquare,
  ArchiveBook,
} from "../CustomComponents/SwiftIcon/Icons";
import { COLOR_VARS } from "../../exports/ColorVars";
import { getDeviceSize } from "../../exports/InteractiveUtils";

const MENU_ITEMS = [
  { name: "Generate Report", icon: DocumentText },
  { name: "Report Schedule", icon: TaskSquare },
  { name: "Report History", icon: ArchiveBook },
];

function ReportManagement() {
  const [menu, setMenu] = useState(MENU_ITEMS[0].name);
  const [menuPopup, setMenuPopup] = useState(false);

  const DEVICE_SIZE = getDeviceSize();

  return (
    <div className="swift-reports-management swift-content">
      {DEVICE_SIZE === "S" && (
        <>
          <div className="swift-submenu-wrapper">
            <ReportsMenu
              menu={menu}
              setMenu={setMenu}
              menuPopup={menuPopup}
              setMenuPopup={setMenuPopup}
            />
          </div>
        </>
      )}
      <div className="strategy-content">
        <ReportDashboard menu={menu} />
      </div>
    </div>
  );
}

function ReportsMenu({ menu, setMenu, menuPopup, setMenuPopup }) {
  function MenuItemClick(menu_item) {
    setMenu(menu_item);
    setMenuPopup(false);
  }

  const selectedMenu = MENU_ITEMS.find((m) => m.name === menu);

  return (
    <>
      {/* <div
        className="swift-submenu-item"
        onClick={() => {
          setMenuPopup(!menuPopup);
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          {selectedMenu?.icon && (
            <selectedMenu.icon size={18} color={COLOR_VARS["SWIFT_COLOR1"]} />
          )}
          <p>{menu}</p>
        </div>
        {menuPopup ? (
          <>
            <ArrowUp2 size={18} color={COLOR_VARS["SWIFT_COLOR1"]} />
          </>
        ) : (
          <>
            <ArrowDown2 size={18} color={COLOR_VARS["SWIFT_COLOR1"]} />
          </>
        )}
      </div> */}
      <div className={"swift-submenu " + (menuPopup ? "active" : "")}>
        {MENU_ITEMS.map((m, index) => {
          return (
            <a key={index}>
              <p
                onClick={() => {
                  MenuItemClick(m.name);
                }}
                className={menu === m.name ? "active" : ""}
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <m.icon
                  size={25}
                  color={
                    menu === m.name
                      ? COLOR_VARS["SWIFT_COLOR1"]
                      : COLOR_VARS["SWIFT_COLOR4"]
                  }
                />
                {m.name}
              </p>
            </a>
          );
        })}
      </div>
    </>
  );
}

export default ReportManagement;
